function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_22130",
  "data-name": "Path 22130",
  d: "M2353.65,1393.848h0a1.732,1.732,0,0,0-.622-1.217,1.822,1.822,0,0,0-2.5.167l-5.974,6.591-3.027-3.181a1.821,1.821,0,0,0-2.5-.108,1.734,1.734,0,0,0-.111,2.5l4.366,4.589a1.811,1.811,0,0,0,1.307.557h.021a1.8,1.8,0,0,0,1.314-.589l7.277-8.03A1.722,1.722,0,0,0,2353.65,1393.848Z",
  transform: "translate(-2338.434 -1392.213)"
});

var SvgCheckmark = function SvgCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15.221,
    height: 11.537,
    viewBox: "0 0 15.221 11.537",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Checkmark.ae89f4fd.svg";
export { ForwardRef as ReactComponent };